import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'next/components/ui';
import ReadOnlyField from 'components/Common/ReadOnlyField';

export default function ToggleableSelect(props) {
  const { operator, readOnlyContent, readOnly } = props;

  if (readOnly) {
    return <ReadOnlyField operator={operator} content={readOnlyContent} />;
  }

  return <Select {...props} />;
}

ToggleableSelect.propTypes = {
  operator: PropTypes.bool,
  readOnly: PropTypes.bool,
  readOnlyContent: PropTypes.string,
};
